import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Appointment } from '../models/appointment';

@Injectable({
  providedIn: 'root',
})
export class AppointmentService {
  private appointmentSource = new BehaviorSubject<Appointment | null>(null);
  currentAppointment = this.appointmentSource.asObservable();

  constructor() {}

  updateAppointment(appointment: Appointment) {
    this.appointmentSource.next(appointment);
  }
}
